import * as types from './types'

/**
 * @author yanyongchao
 * @function: 设置设备信息
 * @param data 设备数组
 */
export const SetEquipmentList = ({ commit }, data) => {
  commit(types.SET_EQUIPMENT_ARRAY, data)
}

/**
 * @author yanyongchao
 * @function 保存设备sn
 * @param data {array} 设备sn
 */
export const SetEquipmentSn = ({ commit }, data) => {
  commit(types.SET_EQUIPMENT_SN, data)
}
